<template>  
  <main role="main" class="main page-product-detail">
    <section class="body-container">
      <div class="content-max-width flex flex-between">
        <div class="gallery">
          
          <div class="main-image">
            <img :src="mainImage" alt="" >
          </div>
          
          <slick ref="slick" class="thumb-slider"
            :options="{ arrows: true, dots: false, slidesToShow: 3, slidesToScroll: 1, }"
          >
            <img v-for="image in product.images" :key="image.main" :src="image.thumbnail" alt="" @click="setAsMain(image)">
          </slick>
        </div>
        
        <div class="content">
          <h1>{{ product.title }}</h1>
          <h4>{{ product.sku }}</h4>
          
          <div class="price">
            <h3><span>$</span>{{ modFormatAmount(product.price) }}</h3>
            <p>+GST</p>
          </div>

          <cart-add-product :product="product"></cart-add-product>

          <div class="wysiwyg" v-html="product.description"></div>

          <app-tabs class="tabs" default-tab="Specifications">
            <template #triggers="{ activeTab, setTab }">
              <ul class="tab">
                <li v-if="product.specs.length" :class="{ active: activeTab == 'Specifications' }"><a @click="setTab('Specifications')">Specifications</a></li>
                <li v-if="product.downloads.length" :class="{ active: activeTab == 'Downloads' }"><a @click="setTab('Downloads')">Downloads</a></li>
                <li v-if="product.videos.length" :class="{ active: activeTab == 'Video' }"><a @click="setTab('Video')">Video</a></li>
              </ul>
            </template>

            <template #tab-content="{ activeTab }">
              <div class="tab-content">
                
                <div v-if="product.specs.length" v-show="activeTab == 'Specifications'" class="wysiwyg">
                  <ul>
                    <li v-for="spec in product.specs" :key="spec.id">{{ spec.title }}</li>
                  </ul>
                </div>
                
                <div v-if="product.downloads.length" v-show="activeTab == 'Downloads'" class="downloads">
                  <div class="download-row flex flex-between" v-for="download in product.downloads" :key="download.id">
                    <div class="title flex">
                      <img src="/images/pdf.svg" alt="">
                      <p>{{ download.title }}</p>
                    </div>
                    <span>{{ download.size }}</span>
                    <a :href="download.url" target="_blank">Download</a>
                  </div>                  
                </div>
                
                <div v-if="product.videos.length" v-show="activeTab == 'Video'" class="wysiwyg">
                  <!-- FE TODO STYLING CHECK DESIGNER FOR EXPECTATIONS -->
                  <div class="video" v-for="video in product.videos" :key="video.id">
                    <iframe width="460" height="260" :src="video.url" :title="video.title" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </div>
                
              </div>
                
            </template>
          </app-tabs>
        </div>
      </div>
    </section>

    <section class="upsell-container" v-if="product.upsells.length">
      <div class="content-max-width">
        <h3 class="title">You might also like…</h3>

        <slick ref="slick" class="upsell-slider"
          :options="{ arrows: true, dots: false, slidesToShow: 5, slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 4,
              slidesToScroll: 1,
                arrows: false,
              }
            },
            
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
              }
            },
            {
              breakpoint: 690,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
              }
            },
            {
              breakpoint: 470,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
              }
            }
          ]}"
        >
          <product-item v-for="upsell in product.upsells" :key="upsell.id" :product="upsell"></product-item>
        </slick>
      </div>
    </section>
  </main>
</template>

<script>
import Slick from 'vue-slick'

export default {
  components: {
    Slick,
  },

  props: {
    product: {
      type: Object,
      required: true,
    }
  },

  data () {
    return {
      mainImage: null,
    }
  },

  mounted () {
    this.mainImage = this.product.images[0].main
  },

  methods: {
    setAsMain (image) {
      this.mainImage = image.main
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-product/Detail.vue